import { Log } from './Log';
import { useParams } from 'react-router-dom';

export const EditQuickLog = () => {
  const { id } = useParams<{ id: string }>();
  const decodedId = decodeURIComponent(id);

  return <Log id={decodedId} />;
};
